import { Zap } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { ActionDto } from '@/Domain/api/Action/dto/Action.dto';
import { ActionsCreateButton } from '@/UI/Actions/Actions.createButton';

type Props = {
  actions: ActionDto[];
};
export const AiActionListEmpty = ({ actions }: Props) => {
  const { t } = useTranslation('actions_page');

  return (
    <div className="flex-1 flex" data-testid="ai-actions-list-empty">
      <div className="flex-1 flex flex-col gap-3 items-center justify-center py-10">
        <Zap className="size-4" />
        <p className="font-medium text-sm text-foreground">{t('list.empty.title')}</p>
        <p className="text-sm text-foreground-subtle text-center">
          <Trans i18nKey="list.empty.description" t={t} />
        </p>
        <div className="mt-4">
          <ActionsCreateButton actions={actions || []} />
        </div>
      </div>
    </div>
  );
};
